import fwUtil from 'framework-util'

export function sendMessageService(data) {
  return custemRequest({
    url: 'txim/sendMessage',
    method: 'post',
    data:data
  })
}


export function getUserSignService() {
  return custemRequest({
    url: 'txim/usersign',
    method: 'post'
  })
}
export function getWebUserSignService(data) {
  return custemRequest({
    url: 'txim/webusersign',
    method: 'post',
    params: data
  })
}


export function dismissRoomService(data) {
  return custemRequest({
    url: 'txim/dismissRoom',
    method: 'post',
    data:data
  })
}

export function getappUserInfo() {
  return custemRequest({
    url: 'userMiddle/list',
    method: 'get'
  })
}
export function getwebUserInfo() {
  return custemRequest({
    url: 'tximWebUserInfo/list',
    method: 'get'
  })
}
export function getuserInfo(userId) {
  return custemRequest({
    url: 'userMiddle/'+userId,
    method: 'get'
  })
}
export function startMixTranscodingConfig(data) {
  return custemRequest({
    url: 'txim/startTranscribe',
    method: 'post',
    data:data
  })
}
export function stopMixTranscodingConfig(data) {
  return custemRequest({
    url: 'txim/stopTranscribe',
    method: 'post',
    data:data
  })
}
export function describeRoomInfo() {
  return custemRequest({
    url: 'txim/DescribeRoomInfo',
    method: 'post',
  })
}

export function getHistoryRoom() {
  return custemRequest({
    url: 'imHistoryRoom/all',
    method: 'get',
  })
}

export function detailRoom(data) {
  return custemRequest({
    url: 'imDetailRoom/',
    method: 'post',
    data:data
  })
}
export function detailHistoryRoom(isinviteId) {
  return custemRequest({
    url: 'imDetailRoom/'+isinviteId,
    method: 'get',
  })
}
//获取录制回调地址
export function OpenBrowserUrl() {
  return custemRequest({
    url: 'txim/OpenBrowserUrl',
    method: 'post',
  })
}
//获取录制回调地址
// export function videoCallback() {
//   return custemRequest({
//     url: 'txim/videoCallback',
//     method: 'post',
//   })
// }
//移除用户
// export function removeUserService(data) {
//   return custemRequest({
//     url: 'txim/removeUser',
//     method: 'post',
//     data:data
//   })
// }



// WEBPACK FOOTER //
// ./src/api/chart/chart/sendMessage.js